import { Directive, ElementRef, NgZone, OnDestroy, OnInit } from '@angular/core';

/**
 * Self-ticking "elapsed seconds" label. It writes its own text node once per
 * second from *outside* the Angular zone, so a running timer never triggers a
 * change-detection pass while a response is streaming. This is the T3 Code
 * `WorkingTimer` pattern: keep the highest-frequency, lowest-importance UI off
 * the framework's render loop entirely.
 */
@Directive({
	standalone: false,
	selector:   '[csElapsedTime]'
})
export class CsElapsedTimeDirective implements OnInit, OnDestroy {
	private startedAt = 0;
	private timer: ReturnType<typeof setInterval> | null = null;

	constructor(
		private readonly el: ElementRef<HTMLElement>,
		private readonly zone: NgZone
	) {}

	ngOnInit(): void {
		this.startedAt = performance.now();
		this.render();
		this.zone.runOutsideAngular(() => {
			this.timer = setInterval(() => this.render(), 1000);
		});
	}

	ngOnDestroy(): void {
		if (this.timer !== null) {
			clearInterval(this.timer);
			this.timer = null;
		}
	}

	private render(): void {
		const seconds = Math.max(0, Math.round((performance.now() - this.startedAt) / 1000));
		this.el.nativeElement.textContent = `${seconds}s`;
	}
}
